<template>
    <div class="webContent flex">
        <div class="top-pic">
            <img src="../../../assets/jifen.png" style="width:100%;height:100%;border:none;" />
            <div class='top-empty'></div>
        </div>

        <div class="me-box">
            <div class="me">
                <div class="userName">{{user}}</div>
                <div class="integration">积分：{{integration}}</div>
            </div>
        </div>

        <div class="title-box">
            <div class="le-title">
                <div class="le-left">
                    <div class="le-index">排名</div>
                    <div class="le-name">姓名</div>
                </div>
                <div class="le-num">积分</div>
            </div>
        </div>

        <div class="le-list">
            <div class="le-info" v-for="(v, i) in list" :key="i" v-if="v.integration > 0">
                <div style="display:flex">
                    <div class="list-order-1" v-if=" i == 0">{{i + 1}}</div>
                    <div class="list-order-2" v-else-if=" i == 1">{{i + 1}}</div>
                    <div class="list-order-3" v-else-if=" i == 2">{{i + 1}}</div>
                    <div class="list-order" v-else >{{i + 1}}</div>

                    <div class="list-name">{{v.name}} ( {{v.mapperNumber}} )</div>
                </div>
                <div class="list-league">
                    <img src="../../../assets/point.png" style="width:0.12rem;height:0.16rem;margin-right:0.05rem"/>
                    <span>{{v.integration}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
		name: 'model_list_page',
		data () {
			return {
                user: '',
                integration: '',
				list: [],
			}
		},

        mounted(){
            this.h5Ajax('get','$/user/info',{}).then(r=>{
				this.user = r.name;
				this.integration = r.integration;
			}).catch(err => {
				console.error('err:' + err)
			})

            this.h5Ajax("get", "$/user/dealerIntegrationRank", {}, true).then( res => {
                this.list = res
            })
        },
        methods: {

        }
    }
</script>

<style scoped>
    @import './league.css';
</style>



// WEBPACK FOOTER //
// src/app/pages/model/list/league.vue